module.exports = __webpack_public_path__ + "static/media/outside_1.6fe704c2.jpeg";